var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-book-carousel"},_vm._l((_vm.images),function(image,index){return _c('div',{key:index,staticClass:"image-container",class:{ active: _vm.currentImage === index }},[_c('img',{attrs:{"src":image}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }